<template>
  <div>
    <mu-flexbox v-if="isLoading" justify="center center" align="center center" style="height: 316px;">
      <mu-flexbox-item align="center">
        <mu-circular-progress :size="46"></mu-circular-progress>
        <br/>
        <span v-text="$t('message.loadingText')"></span>
      </mu-flexbox-item>
    </mu-flexbox>
    <div v-if="!isLoading">
      <mu-card-header titleClass="largeTitle boldTitle" :title="title" :subTitle="subTitle"></mu-card-header>
      <mu-list>
        <mu-list-item disableRipple :title="$t('message.notificationPreferencesQuestionReplies')"
                      @click="model.answer = !model.answer">
          <div slot="default" style="color:#767676;">{{ $t('message.notificationPreferencesQuestionRepliesSubLine') }}
          </div>
          <mu-switch v-model="model.answer" slot="right"/>
        </mu-list-item>
        <mu-list-item disableRipple :title="$t('message.notificationPreferencesNewFollower')"
                      @click="model.follow = !model.follow">
          <div slot="default" style="color:#767676">{{ $t('message.notificationPreferencesNewFollowerSubLine') }}</div>
          <mu-switch v-model="model.follow" slot="right"/>
        </mu-list-item>
      </mu-list>
      <mu-card-text>
        <mu-raised-button
          class="large"
          :disabled="isSaving"
          @click.native="submitForm"
          secondary
          :label="isSaving ? $t('message.updatingText') : $t('message.updateText')"
          fullWidth
        ></mu-raised-button>
      </mu-card-text>
    </div>
    <mu-snackbar
      v-if="snackbar"
      message="Updated notification preferences"
      action="Ok"
      @actionClick="hideSnackbar"
      @close="hideSnackbar"
    />
  </div>
</template>
<script>
  import SettingsApi from '../../api/Settings'

  export default {
    name: 'settings-notifications',
    data() {
      return {
        title: this.$t('message.notificationPreferencesTitle'),
        subTitle: this.$t('message.notificationPreferencesSubTitle'),
        model: {},
        isSaving: false,
        isLoading: true,
        snackbar: false
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/settings/notifications');
      setTimeout(function () {
        SettingsApi.getNotificationSettings()
          .then(function (response) {
            self.isLoading = false;
            self.model = response.data;
          })
          .catch(function () {
            self.isLoading = false;
            self.model = {}
          })
      }.bind(self), 300)
    },
    methods: {
      submitForm() {
        let self = this;
        self.isSaving = true;
        SettingsApi.putNotificationSettings(self.model)
          .then(function (response) {
            self.isSaving = false;
            self.$toastr.success("Updated notifications");
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Notifications.vue?c28d8718